import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Greetings! I am <span className="purple">Ahmed Rabea, </span>a
            dedicated web developer based in Egypt with a strong foundation in
            <span className="purple"> HTML, CSS, JavaScript</span>. My
            expertise extends to technologies like{" "}
            <span className="purple"> React, Node.js, Express</span>, and I
            excel in database management using <span className="purple">MongoDB and PostgreSQL</span>.
            Proficient in <span className="purple"> Redux, GraphQL, SASS</span>.</p>
            
            <p style={{ textAlign: "justify" }}>
            Explore my journey further
            through my LinkedIn, GitHub, and portfolio to discover the
            innovative projects I've undertaken. I am currently open to exciting
            job opportunities.
          </p>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Websites should look good from the inside and out."{" "}
          </p>
          <footer className="blockquote-footer">
            Paul Cookson
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
